
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[client]",
      function () {
        return require("private-next-pages/[client]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[client]"])
      });
    }
  